import axios from 'axios';

function authHeaders(token) {
  return {
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

function toMatrixSnapshot(data) {
  return {
    columns: data.columns || [],
    rows: data.rows || [],
    cells: data.cells || {},
    customCounts: data.custom_counts || {},
  };
}

export async function fetchLicenseMatrix({ appHostname, token }) {
  const formData = new FormData();
  const response = await axios.post(`${appHostname}/api/product/license/getmatrix`, formData, {
    headers: authHeaders(token),
  });
  return response.data;
}

export async function fetchLicenseList({ appHostname, token }) {
  const formData = new FormData();
  const response = await axios.post(`${appHostname}/api/product/license/getlist`, formData, {
    headers: authHeaders(token),
  });
  return response.data;
}

export async function fetchLicenseDetail({ appHostname, token, licenseId }) {
  const formData = new FormData();
  formData.append('license_id', licenseId);
  const response = await axios.post(`${appHostname}/api/product/license/getdetail`, formData, {
    headers: authHeaders(token),
  });
  return response.data;
}

export async function addLicense({
  appHostname,
  token,
  username,
  name,
  description,
  categoryAccess,
  productAccess,
}) {
  const formData = new FormData();
  formData.append('license_name', name);
  formData.append('license_desc', description || '');
  formData.append('category_access', JSON.stringify(categoryAccess || {}));
  formData.append('product_access', JSON.stringify(productAccess || {}));
  formData.append('username', username || '');
  const response = await axios.post(`${appHostname}/api/product/license/add`, formData, {
    headers: authHeaders(token),
  });
  return response.data;
}

export async function editLicense({
  appHostname,
  token,
  username,
  licenseId,
  description,
  categoryAccess,
  productAccess,
}) {
  const formData = new FormData();
  formData.append('license_id', licenseId);
  formData.append('license_desc', description || '');
  formData.append('category_access', JSON.stringify(categoryAccess || {}));
  formData.append('product_access', JSON.stringify(productAccess || {}));
  formData.append('username', username || '');
  const response = await axios.post(`${appHostname}/api/product/license/edit`, formData, {
    headers: authHeaders(token),
  });
  return response.data;
}

export async function deleteLicense({ appHostname, token, username, licenseId }) {
  const formData = new FormData();
  formData.append('license_id', licenseId);
  formData.append('username', username || '');
  const response = await axios.post(`${appHostname}/api/product/license/delete`, formData, {
    headers: authHeaders(token),
  });
  return response.data;
}

export async function fetchAllProductItems({ appHostname, token }) {
  const allItems = [];
  let cursor = '';

  let hasMore = true;
  while (hasMore) {
    const url = `${appHostname}/api/product/item/getlist?cursor=${encodeURIComponent(cursor)}&limit=50`;
    const formData = new FormData();
    const response = await axios.post(url, formData, {
      headers: authHeaders(token),
    });
    if (response.data.status !== 'OK') {
      throw new Error(response.data.message || 'โหลดรายการสินค้าไม่สำเร็จ');
    }
    allItems.push(...(response.data.products_item || []));
    if (!response.data.has_more) {
      hasMore = false;
    } else {
      cursor = response.data.next_cursor;
    }
  }

  return allItems;
}

export async function searchProductItems({ appHostname, token, search, limit = 20 }) {
  const trimmed = (search || '').trim();
  if (!trimmed) {
    return [];
  }

  const params = new URLSearchParams({
    search_only: '1',
    limit: String(limit),
    search: trimmed,
  });
  const formData = new FormData();
  const response = await axios.post(
    `${appHostname}/api/product/item/getlist?${params.toString()}`,
    formData,
    {
      headers: authHeaders(token),
    },
  );
  if (response.data.status !== 'OK') {
    throw new Error(response.data.message || 'ค้นหาสินค้าไม่สำเร็จ');
  }

  return (response.data.products_item || []).map((item) => ({
    id: item.productitem_id,
    name: item.productitem_name,
    code: item.productitem_id,
    inter: item.productitem_inter || '',
    barcode: item.productitem_barcode || '',
    categoryId: item.productcategory_id,
  }));
}

export { toMatrixSnapshot };
